/**
 * Strips ?variant= parameter from all product card links inside Nosto placement containers.
 * Uses MutationObserver to catch dynamically injected Nosto content.
 */
(function () {
  'use strict';

  var NOSTO_IDS = ['productpage-nosto-2', 'productpage-nosto-3', 'bag-recommendations', 'oli-rec-nosto', 'searchpage', 'searchpage-no-results','categorypage-nosto-1'];

  function stripVariantFromLinks(container) {
    var links = container.querySelectorAll('a[href*="variant"]');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      try {
        var url = new URL(link.href);
        if (url.searchParams.has('variant')) {
          url.searchParams.delete('variant');
          link.href = url.toString();
        }
      } catch (e) {
        // skip malformed URLs
      }
    }
  }

  function observeNostoContainer(id) {
    var el = document.getElementById(id);
    if (!el) return;

    // Fix any links already present
    stripVariantFromLinks(el);

    // Watch for future content injected by Nosto
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          stripVariantFromLinks(el);
        }
      }
    });

    observer.observe(el, { childList: true, subtree: true });
  }

  function init() {
    for (var i = 0; i < NOSTO_IDS.length; i++) {
      observeNostoContainer(NOSTO_IDS[i]);
    }

    // Also observe document body for Nosto containers that may appear later
    var bodyObserver = new MutationObserver(function () {
      for (var i = 0; i < NOSTO_IDS.length; i++) {
        var el = document.getElementById(NOSTO_IDS[i]);
        if (el && !el.dataset.nostoLinkFixObserved) {
          el.dataset.nostoLinkFixObserved = 'true';
          observeNostoContainer(NOSTO_IDS[i]);
        }
      }
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
